import React, { Component } from 'react';

import AdminLayout from './layout';

import { vendorDashboard, getVendorInfo } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import PdfContainer from './Transaction/PdfContainerReports';
import Doc from './Transaction/DocService';

import { Chart } from 'chart.js';

const optionsN = {
scales: {
  yAxes: [{
      ticks: {
          beginAtZero: true
      }
  }],

}
}  

class singleReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
          school_data: [],
          vendor_id : this.props.match.params.id
        };
        
    }

    componentDidMount() {

        let userinfo = JSON.stringify({
        vendor_id: this.state.vendor_id,
        });

        getVendorInfo(userinfo).then((response) => {
        if (response.status === 1) {
            let data = response.results[0];

            let req = {
                url: 'school_data'
            };
    
            req.user_id = data.login_id;
            req.category = data.category_id;
            req.url = 'like_follow_chart';
            vendorDashboard(JSON.stringify(req)).then(response => {
    
                if (response.status === 1) {
                    this.setLike(response.result);
                }
            });
    
            req.url = 'leads';
            vendorDashboard(JSON.stringify(req)).then(response => {
    
                if (response.status === 1) {
                    this.setLeads(response.result);
                }
            });



            req.url = 'rating_chart';
            vendorDashboard(JSON.stringify(req)).then(response => {
    
                if (response.status === 1) {
                    this.setReviews(response.result);
                }
            });

            req.url = 'enquiries';
            vendorDashboard(JSON.stringify(req)).then(response => {
    
                if (response.status === 1) {
                    this.setEnquiries(response.result);
                }
            });


        }
        });

       

    }

    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };  
  
    setLeads = (data) => {

        var ctx = document.getElementById('barChartLeads');
         new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }        

    setLike = (data) => {

        var ctx = document.getElementById('barChartLikeFollows');
         new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }       

    setReviews = (data) => {

        var ctx = document.getElementById('barChartReviews');
         new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }       

    setEnquiries = (data) => {

        var ctx = document.getElementById('barChartEnquiries');
         new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }     

    createPdf = (html) => Doc.createPdf(html);

    render() {

        return (
            <React.Fragment>
                <AdminLayout>
                    
                        <div class="row  mt-3">
              <div class="col-xl-12 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Full Report - Partner/Institutions</h4>
                    </div>
                    <div class="row">
                    
                      <div class="col-12">
                      <PdfContainer createPdf={this.createPdf}>
                        <div class="row">
                           

                        <div class="col-xl-6 d-flex grid-margin stretch-card">
                            <div class="card">
                            <div class="card-body">
                                <div class="d-flex flex-wrap justify-content-between">
                                <h4 class="card-title mb-3">Likes and Follows</h4>
                                
                                </div>
                                <div class="row">
                                <div class="col-12">
                                    <canvas id="barChartLikeFollows"></canvas>
                                </div>
                                </div>
                            </div>
                            </div>
                            </div>

                            <div class="col-xl-6 d-flex grid-margin stretch-card">
                            <div class="card">
                            <div class="card-body">
                                <div class="d-flex flex-wrap justify-content-between">
                                <h4 class="card-title mb-3">Reviews</h4>
                                
                                </div>
                                <div class="row">
                                <div class="col-12">
                                    <canvas id="barChartReviews"></canvas>
                                </div>
                                </div>
                            </div>
                            </div>
                            </div>

                            <div class="col-xl-6 d-flex grid-margin stretch-card">
                            <div class="card">
                            <div class="card-body">
                                <div class="d-flex flex-wrap justify-content-between">
                                <h4 class="card-title mb-3">Leads</h4>
                                
                                </div>
                                <div class="row">
                                <div class="col-12">
                                    <canvas id="barChartLeads"></canvas>
                                </div>
                                </div>
                            </div>
                            </div>
                            </div>
               

                            <div class="col-xl-6 d-flex grid-margin stretch-card">
                            <div class="card">
                            <div class="card-body">
                                <div class="d-flex flex-wrap justify-content-between">
                                <h4 class="card-title mb-3">Enquiries</h4>
                                
                                </div>
                                <div class="row">
                                <div class="col-12">
                                <canvas id="barChartEnquiries"></canvas>    
                                </div>
                                </div>
                            </div>
                            </div>
                            </div>


                          
                        </div>
                      </PdfContainer>  
                      </div>
                    
                    </div>
                  </div>
                </div>
              </div>

                                     

            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default singleReport;


// WEBPACK FOOTER //
// ./src/components/bewise/singleReport.jsx